<template>
  <FunnelTravel v-bind="funnelData">
    <template #collectivity-picker>
      <ScPlaceholder name="jss-content" :rendering="rendering" />
    </template>
  </FunnelTravel>
</template>

<script>
import * as Cycle from '@aon/cycle'
import { mapValues } from 'lodash'
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'

export default {
  name: 'CycleFunnelTravelSitecore',
  components: {
    FunnelTravel: Cycle.CycleFunnelTravelSitecore,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  computed: {
    funnelData() {
      return {
        ...this.textContent,
        ...this.renderingWithoutFields,
        serviceInfo: this.fields.serviceInfo
      }
    },
    textContent() {
      return mapValues(this.fields, (item) => item.value ?? item)
    },
    renderingWithoutFields() {
      // Fields are somehow duplicated in the rendering prop, we'll remove them here
      return { ...this.rendering, fields: {} }
    }
  }
}
</script>
